<app-alerts />

@if (data$ | async; as data) {
  <app-dictionary-details-form
    [data]="data"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
